import type { AssignmentSpecification } from '../@types/AssignmentSpecification';
import type { BranchAssignmentSpecification } from '../@types/BranchAssignmentSpecification';
import type { Actions } from '../actions';
import { REQ_BRANCH } from '../actions/branch';
import {
  RCV_ASSIGNMENT_OPTION,
  RCV_ASSIGNMENT_OPTION_LIST,
  RCV_UPDATE_ASSIGNMENT_OPTION,
  REQ_ASSIGNMENT_OPTION,
  REQ_ASSIGNMENT_OPTION_LIST,
  REQ_UPDATE_ASSIGNMENT_OPTION,
  REQUEST_FAILED,
} from '../actions/branch-assignment-options';
import { requestStatus, responseStatus } from '../shared/statuses';

interface BranchAssignmentOptionsState {
  requestStatus: number;
  responseStatus: number;
  option: AssignmentSpecification | null;
  list: BranchAssignmentSpecification[];
}

const _initialState: BranchAssignmentOptionsState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  option: null,
  list: [],
};

const assignmentOptionReducer = (
  state: BranchAssignmentOptionsState = _initialState,
  action: Actions,
): BranchAssignmentOptionsState => {
  switch (action.type) {
    case REQ_ASSIGNMENT_OPTION_LIST:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_ASSIGNMENT_OPTION_LIST:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
        list: action.response,
      };
    case REQ_ASSIGNMENT_OPTION:
      return {
        ...state,
        requestStatus: requestStatus.FETCHING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_ASSIGNMENT_OPTION:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
        option: action.response,
      };
    case REQ_UPDATE_ASSIGNMENT_OPTION:
      return {
        ...state,
        requestStatus: requestStatus.UPDATING,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_UPDATE_ASSIGNMENT_OPTION:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
        option: action.response,
      };
    case REQ_BRANCH:
      return {
        ...state,
        option: null,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default assignmentOptionReducer;
